export const configCountries = {
    1: 'UAE',
    2: 'Kuwait',
    3: 'KSA',
};
